import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { Form, Input, Modal, notification, Radio, Spin } from 'antd'
import {
  insertCheckSuggestion,
  updateCheckSuggestion
} from '../../../common/request'
import ResponseCode from '../../../common/response-code'
import { errorModal } from '../../../plugins/utils'
import {
  STATUS_FORM_OPTIONS,
  SUGGESTION_MAX_LENGTH,
  TITLE_MAX_LENGTH
} from './checkSuggestionConstants'

/** 机构管理-机构配置-审核建议-弹窗 */
const CheckSuggestionModal = forwardRef((props, ref) => {
  const [form] = Form.useForm()
  const [show, setShow] = useState(false)
  const [currentId, setCurrentId] = useState('')
  const [modalType, setModalType] = useState('insert')
  const [title, setTitle] = useState('')
  const [loading, setLoading] = useState(false)

  useImperativeHandle(ref, () => {
    return { showModal }
  })

  const showModal = (type, data) => {
    const titleMappings = { insert: '新增审核建议', update: '编辑审核建议' }
    setTitle(titleMappings[type])
    setModalType(type)
    form.resetFields()
    if (type === 'update') {
      setCurrentId(data.id)
      form.setFieldsValue({
        title: data.title,
        suggestion: data.suggestion,
        status: data.status
      })
    } else {
      setCurrentId('')
      form.setFieldsValue({ status: 1 })
    }
    setShow(true)
  }

  const closeModal = () => {
    setShow(false)
    form.resetFields()
    setCurrentId('')
  }

  const submit = async () => {
    try {
      const formData = await form.validateFields()
      operate(formData)
    } catch (error) {}
  }

  const operate = async (formData) => {
    setLoading(true)
    try {
      const params = {
        orgId: props.orgId,
        title: formData.title?.trim(),
        suggestion: formData.suggestion?.trim(),
        status: formData.status
      }
      if (modalType === 'update') params.id = currentId
      const api = modalType === 'insert' ? insertCheckSuggestion : updateCheckSuggestion
      const res = await api(params)
      setLoading(false)
      if (res.code !== ResponseCode.success) return errorModal(res.msg)
      notification.success({ message: '操作成功' })
      closeModal()
      props.onSuccess?.()
    } catch (error) {
      setLoading(false)
      console.error(error)
      errorModal('网络错误，操作失败')
    }
  }

  return (
    <Modal
      open={show}
      title={title}
      onCancel={closeModal}
      onOk={submit}
      confirmLoading={loading}
    >
      <Spin spinning={loading}>
        <Form
          className="my-4"
          form={form}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 14 }}
        >
          <Form.Item
            label="建议标题"
            name="title"
            rules={[
              { required: true, message: '请输入建议标题' },
              { max: TITLE_MAX_LENGTH, message: `建议标题不能超过${TITLE_MAX_LENGTH}字` }
            ]}
          >
            <Input
              placeholder="请输入建议标题"
              maxLength={TITLE_MAX_LENGTH}
              showCount
            />
          </Form.Item>
          <Form.Item
            label="建议内容"
            name="suggestion"
            rules={[{ required: true, message: '请输入建议内容' }]}
          >
            <Input.TextArea
              placeholder="请输入建议内容"
              rows={4}
              maxLength={SUGGESTION_MAX_LENGTH}
              showCount
              style={{ resize: 'none' }}
            />
          </Form.Item>
          <Form.Item
            label="状态"
            name="status"
            rules={[{ required: true, message: '请选择状态' }]}
          >
            <Radio.Group options={STATUS_FORM_OPTIONS} />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  )
})

export default CheckSuggestionModal
